import React, { Component } from 'react';
import PageTitle from '../components/PageTitle';

class PageNotFound extends Component {
    render() {
        return (
            <div>
                <PageTitle title="Pagina non trovata" bgimgurl="/img/titlebg/concerti.jpg"></PageTitle>
                <div className="container">
                    <div className="row">
                        <div class="col-12">
                            Pagina non trovata
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/pages/NotFound.js